import React, { createContext, useState, useEffect } from "react";
import { fetchOrderStock, fetchReadyStock } from "../APICalls";
import { apibasePath } from "../config";

export const ProductsListContext = createContext();

export const ProductsListsProvider = ({ children }) => {



  //   const handleStockFilter = async (i) => {
  //     setselectedStockFilter(i);
  //     if (i==selectedStockFilter) {
  //       return;
  //     }
  //     if (i == 0) {
  //       const data1 = await fetchOrderStock();
  //       const data2 = await fetchReadyStock();
  //       setDisplayData([
  //         ...(data1?.results || []),
  //         ...(data2?.results || [])
  //       ]);

  //     } else if (i == 1) {
  //       const data = await fetchOrderStock();
  //       setDisplayData(data?.results);
  //     } else {
  //       const data = await fetchReadyStock();
  //       setDisplayData(data?.results);
  //     }
  //   };

  const stockFilters = ["Order Stock", "Ready Stock"];
  const [selectedStockFilter, setselectedStockFilter] = useState(1);
  const [ProductsAPI, setProductsAPI] = useState(`${apibasePath}/client/customer-stock-multiple-items/`)
  const [sizesAPI, setSizesAPI] = useState(`${apibasePath}/client/item-available-sizes/`);

  const [Allproducts, setAllproducts] = useState([]);
  const [allSizes, setallSizes] = useState([])

  async function fetchProductsandSizes(type) {
    const data = await type === 'order-stock' ? fetchOrderStock() : fetchReadyStock();
    // const sizes = await  type == 'order-stock' ? fet
    if (data?.error) {
      console.log("Error Fetching PRoducts", data?.error);
      return;
    }
    setAllproducts(data)
  }
 

  useEffect(() => {
    if (selectedStockFilter == 0) {
      setProductsAPI(`${apibasePath}/client/customer-item-order-stock-list/`);
      setSizesAPI(`${apibasePath}/client/order-stock-available-sizes/`);
      fetchProductsandSizes('order-stock')

    } else if (selectedStockFilter == 1) {
      setProductsAPI(`${apibasePath}/client/customer-stock-multiple-items/`);
      setSizesAPI(`${apibasePath}/client/item-available-sizes/`)
      fetchProductsandSizes('ready-stock')

    }
  }, [selectedStockFilter])


  return (
    <ProductsListContext.Provider value={{ setselectedStockFilter, selectedStockFilter, stockFilters, ProductsAPI, sizesAPI }}>
      {children}
    </ProductsListContext.Provider>
  );
};
